import * as init from './001-init.js'

export default {
  '001': init,
}
